(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["docuseries--about-us"] && !Shopify.designMode) return;
  try {
    
  class AboutDocuseriesPlayer extends HTMLElement {
    /** @type {HTMLButtonElement|null} */
    #playButton = null;

    /** @type {HTMLVideoElement|null} */
    #video = null;

    connectedCallback() {
      this.#playButton = this.querySelector('[data-about-docuseries-play]');
      const media = this.querySelector('.about-docuseries__file');
      this.#video = media instanceof HTMLVideoElement ? media : media?.querySelector('video');

      if (!this.#playButton) return;

      this.#playButton.addEventListener('click', this.#playVideo);
      this.#video?.addEventListener('ended', this.#resetPlayer);
    }

    disconnectedCallback() {
      this.#playButton?.removeEventListener('click', this.#playVideo);
      this.#video?.removeEventListener('ended', this.#resetPlayer);
    }

    #playVideo = async () => {
      if (!this.#playButton) return;

      const youtubeId = this.dataset.youtube;
      const vimeoId = this.dataset.vimeo;

      if (this.#video instanceof HTMLVideoElement) {
        this.classList.add('is-playing');
        this.#video.controls = true;

        try {
          await this.#video.play();
        } catch {
          this.#resetPlayer();
        }

        return;
      }

      if (youtubeId) {
        this.#embedIframe(
          `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`,
          'autoplay; encrypted-media; fullscreen'
        );
        return;
      }

      if (vimeoId) {
        this.#embedIframe(
          `https://player.vimeo.com/video/${vimeoId}?autoplay=1&portrait=0`,
          'autoplay; fullscreen'
        );
      }
    };

    /**
     * @param {string} src
     * @param {string} allow
     */
    #embedIframe = (src, allow) => {
      const iframe = document.createElement('iframe');
      iframe.className = 'about-docuseries__iframe';
      iframe.src = src;
      iframe.allow = allow;
      iframe.setAttribute('allowfullscreen', '');
      iframe.title = this.dataset.title || 'Video';
      this.classList.add('is-playing');
      this.append(iframe);
    };

    #resetPlayer = () => {
      if (!this.#video) return;

      this.#video.controls = false;
      this.classList.remove('is-playing');
    };
  }

  if (!customElements.get('about-docuseries-player')) {
    customElements.define('about-docuseries-player', AboutDocuseriesPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  // Blog Filter Dropdown Handler
  document.addEventListener('DOMContentLoaded', function() {
    var filterSelect = document.getElementById('BlogTagFilter');
    
    if (filterSelect) {
      filterSelect.addEventListener('change', function () {
        if (this.value) {
          // Add loading state to dropdown
          this.style.opacity = '0.5';
          this.style.pointerEvents = 'none';
          window.location.href = this.value;
        }
      });
    }

    // Add loading states to filter links
    var filterLinks = document.querySelectorAll('.blog-filter__menu .blog-list__link a');
    filterLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        // Add loading class to parent li for immediate visual feedback
        var listItem = this.closest('.blog-list__link');
        if (listItem) {
          listItem.classList.add('loading');
        }
        // Navigation happens immediately - no artificial delay
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video--about-us"] && !Shopify.designMode) return;
  try {
    
  class AboutVideoPlayer extends HTMLElement {
    /** @type {HTMLButtonElement|null} */
    #playButton = null;

    /** @type {HTMLVideoElement|null} */
    #video = null;

    connectedCallback() {
      this.#playButton = this.querySelector('[data-about-video-play]');
      const media = this.querySelector('.about-video__file');
      this.#video = media instanceof HTMLVideoElement ? media : media?.querySelector('video');

      if (!this.#playButton || !(this.#video instanceof HTMLVideoElement)) return;

      this.#playButton.addEventListener('click', this.#playVideo);
      this.#video.addEventListener('ended', this.#resetPlayer);
    }

    disconnectedCallback() {
      this.#playButton?.removeEventListener('click', this.#playVideo);
      this.#video?.removeEventListener('ended', this.#resetPlayer);
    }

    #playVideo = async () => {
      if (!this.#playButton || !(this.#video instanceof HTMLVideoElement)) return;

      this.#video.controls = true;
      this.#playButton.setAttribute('hidden', '');

      try {
        await this.#video.play();
      } catch {
        this.#resetPlayer();
      }
    };

    #resetPlayer = () => {
      if (!this.#playButton || !this.#video) return;

      this.#video.controls = false;
      this.#playButton.removeAttribute('hidden');
    };
  }

  if (!customElements.get('about-video-player')) {
    customElements.define('about-video-player', AboutVideoPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
